import { lazy } from "react";

const MyPagePassword = lazy(() => import("app/pages/mypage/MyPagePassword"));
const MyPageDetail = lazy(() => import("app/pages/mypage/MyPageDetail"));
const AlarmList = lazy(() => import("app/pages/mypage/AlarmList"));

export const mpRouter: any[] = [
  {path: 'mypage', element: <MyPagePassword />},
  {path: 'mypage/:type?', element: <MyPageDetail />},
  // 알림 목록(헤더 종 아이콘의 "전체 보기")
  {path: '/alarms', element: <AlarmList />},
];